import { AppState } from '../../common/configuration/app.states';

export const getCalendarEvents = (state: AppState) => state.calendar.calendarEvents;
